/*!

=========================================================
* Argon Dashboard PRO React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState } from 'react'
// react library for routing
import { useLocation, NavLink as NavLinkRRD, Link } from 'react-router-dom'
// nodejs library that concatenates classes
import classnames from 'classnames'
// nodejs library to set properties for components
import { PropTypes } from 'prop-types'
// react library that creates nice scrollbar on windows devices
import PerfectScrollbar from 'react-perfect-scrollbar'
// reactstrap components
import AxiosInstance from 'utils/AxiosInstance'
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Button,
} from 'reactstrap'
import { useSelector, useDispatch } from 'react-redux'
import { fetchUserPrivileges } from 'store/Users/actions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBars,
  faChevronDown,
  faChevronRight,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'

// Global Css Leon
import '../../assets/css/Global/style.css'
import { setShowSidebarDropdownChildRoutes } from 'store/ConfigurationSettings/GeneralConfig/actions'

function Sidebar({
  toggleSidenav = () => {},
  sidenavOpen = false,
  routes = [{}],
  logo,
  rtlActive = false,
}) {
  const dispatch = useDispatch()
  const [refreshed, setRefreshed] = useState(false)
  const [previewLogo, setPreviewLogo] = useState(null)
  const [previewTheme, setPreviewTheme] = useState({})

  const languageRedux = useSelector((state) => state.language)

  const language = languageRedux || {}

  const [state, setState] = React.useState({})
  const location = useLocation()
  const { theme } = useSelector((state) => state.themeConfig)
  const { userNavigation } = useSelector((state) => state.users)
  const { user } = useSelector((state) => state.auth)
  const { showSidebarDropdownChildRoutes } = useSelector(
    (state) => state.generalConfig
  )

  useEffect(() => {
    const route = routes?.find((r) => r?.path === location.pathname)
    if (route?.dropdown && !showSidebarDropdownChildRoutes && !refreshed) {
      dispatch(setShowSidebarDropdownChildRoutes(true))
    }

    setRefreshed(true)
  }, [
    routes,
    location.pathname,
    dispatch,
    showSidebarDropdownChildRoutes,
    refreshed,
  ])

  useEffect(() => {
    const route = routes?.find((r) =>
      r?.path.includes(location.pathname.split('/')[1])
    )
    if (showSidebarDropdownChildRoutes && !route?.dropdown) {
      dispatch(setShowSidebarDropdownChildRoutes(false))
    }
  }, [dispatch, location.pathname, routes, showSidebarDropdownChildRoutes])

  useEffect(() => {
    dispatch(fetchUserPrivileges())
  }, [dispatch])

  // Listen for preview messages from admin iframe
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== 'http://localhost:5173') return

      if (event.data.type === 'UPDATE_LEARNING_PREVIEW') {
        const {
          navigationLogo,
          favicon,
          sidebarBackground,
          sidebarActiveItemColor,
          sidebarTextColor,
        } = event.data

        // Update preview logo
        if (navigationLogo) {
          setPreviewLogo(navigationLogo)
        } else {
          setPreviewLogo(null)
        }

        // Update favicon
        if (favicon) {
          let link =
            document.querySelector("link[rel*='icon']") ||
            document.createElement('link')
          link.type = 'image/x-icon'
          link.rel = 'shortcut icon'
          link.href = favicon
          document.getElementsByTagName('head')[0].appendChild(link)
        }

        // Update theme colors
        setPreviewTheme({
          sidebarBackground,
          sidebarActiveItemColor,
          sidebarTextColor,
        })
      }
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [])

  const token = localStorage.getItem('token')
  let hostname = window.location.hostname
  console.log(hostname, 'hostname')
  const onSwitchApps = (event) => {
    let client
    if (hostname === 'localhost') {
      client = `http://localhost:8000/login?token=${token}`
    } else if (hostname.includes('v2')) {
      client = `https://kiwi-release.startkiwi.com?token=${token}`
    } else {
      const clientFromWindow =
        window.location && window.location.hostname.includes('-')
          ? window.location.hostname.split('-')[1]
          : window.location.hostname

      let clientKiwi = clientFromWindow && clientFromWindow.split('.')[0]
      client = `https://${clientKiwi}.startkiwi.com?token=${token}`
    }
    const redirectUrl = client

    window.location.href = redirectUrl
  }
  React.useEffect(() => {
    setState(getCollapseStates(routes))

    // return () => {
    // 	document.body.classList.remove('g-sidenav-pinned')
    // 	document.body.classList.add('g-sidenav-hidden')
    // }
    // eslint-disable-next-line
  }, [])
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? 'active' : ''
  }

  // makes the sidenav normal on hover (actually when mouse enters on it)
  // const onMouseEnterSidenav = () => {
  //   if (!document.body.classList.contains('g-sidenav-pinned')) {
  //     document.body.classList.add('g-sidenav-show')
  //   }
  // }
  // makes the sidenav mini on hover (actually when mouse leaves from it)
  const onMouseLeaveSidenav = () => {
    if (!document.body.classList.contains('g-sidenav-pinned')) {
      document.body.classList.remove('g-sidenav-show')
    }
  }
  // this creates the intial state of this component based on the collapse routes
  // that it gets through routes
  const getCollapseStates = (routes) => {
    let initialState = {}
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: getCollapseInitialState(prop.views),
          ...getCollapseStates(prop.views),
          ...initialState,
        }
      }
      return null
    })
    return initialState
  }
  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.js - route /regular-forms
  const getCollapseInitialState = (routes) => {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && getCollapseInitialState(routes[i].views)) {
        return true
      } else if (location.pathname.indexOf(routes[i].path) !== -1) {
        return true
      }
    }
    return false
  }
  // this is used on mobile devices, when a user navigates
  // the sidebar will autoclose
  const closeSidenav = () => {
    if (window.innerWidth < 1200) {
      toggleSidenav()
    }
  }
  // this function creates the links and collapses that appear in the sidebar (left menu)
  const createLinks = (routes) => {
    if (!userNavigation || !Array.isArray(userNavigation)) {
      return []
    }

    const userNavigationKeys =
      userNavigation?.map((userNav) => userNav?.key) || []

    const routesFiltered =
      routes?.filter((route) => {
        // Check if route is in user navigation
        if (!userNavigationKeys.includes(route?.key)) {
          return false
        }

        // Check hideFor property - if route should be hidden for current user's access level
        if (
          route?.hideFor &&
          user?.access &&
          route.hideFor.includes(user.access)
        ) {
          return false
        }

        // Show by default if passes all checks
        return true
      }) || []

    return routesFiltered.map((prop, key) => {
      if (prop.redirect) {
        return null
      }

      if (prop.collapse) {
        var st = {}
        st[prop['state']] = !state[prop.state]
        return (
          <NavItem key={key}>
            <NavLink
              href='#pablo'
              data-toggle='collapse'
              aria-expanded={state[prop.state]}
              onClick={(e) => {
                e.preventDefault()
                setState(st)
              }}
            >
              {prop.icon ? (
                <>
                  <i className={prop.icon} />
                  <span className='nav-link-text'>{prop.name}</span>
                </>
              ) : prop.miniName ? (
                <>
                  <span className='sidenav-mini-icon'> {prop.miniName} </span>
                  <span className='sidenav-normal'> {prop.name} </span>
                </>
              ) : null}
            </NavLink>
            <Collapse isOpen={state[prop.state]}>
              <Nav className='nav-sm flex-column'>
                {createLinks(prop.views)}
              </Nav>
            </Collapse>
          </NavItem>
        )
      }

      return (
        <NavItem className={activeRoute(prop.layout + prop.path)} key={key}>
          <NavLink
            to={prop.layout + prop.path}
            activeClassName=''
            onClick={() => {
              if (prop.dropdown) {
                if (!showSidebarDropdownChildRoutes) {
                  dispatch(setShowSidebarDropdownChildRoutes(true))
                } else {
                  dispatch(setShowSidebarDropdownChildRoutes(false))
                }
              }

              closeSidenav()
            }}
            tag={NavLinkRRD}
            style={{
              backgroundColor: activeRoute(prop.layout + prop.path)
                ? previewTheme.sidebarActiveItemColor ||
                  theme.sidebarActiveColor
                : 'unset',
              color: previewTheme.sidebarTextColor || theme.sidebarTextColor,
            }}
          >
            {prop.icon !== undefined ? (
              <>
                <i className={prop.icon} />
                <span className='nav-link-text'>{prop.name}</span>
              </>
            ) : prop.miniName !== undefined ? (
              <>
                <span className='sidenav-mini-icon'> {prop.miniName} </span>
                <span className='sidenav-normal'> {prop.name} </span>
              </>
            ) : (
              prop.name
            )}
            {(prop.dropdown &&
              activeRoute(prop.layout + prop.path) !== 'active') ||
            (prop.dropdown &&
              activeRoute(prop.layout + prop.path) &&
              !showSidebarDropdownChildRoutes) ? (
              <FontAwesomeIcon
                icon={faChevronRight}
                className='ml-5'
                size='sm'
              />
            ) : null}

            {prop.dropdown &&
              activeRoute(prop.layout + prop.path) === 'active' &&
              showSidebarDropdownChildRoutes && (
                <FontAwesomeIcon
                  icon={faChevronDown}
                  className='ml-5'
                  size='sm'
                />
              )}
          </NavLink>

          {prop.dropdown &&
            showSidebarDropdownChildRoutes &&
            prop.childRoutes
              .filter((el) => !el?.hide)
              .map((el) => (
                <NavItem className={activeRoute(el.path)} key={el.name}>
                  <NavLink
                    to={el.path}
                    activeClassName=''
                    onClick={() => {
                      closeSidenav()
                    }}
                    tag={NavLinkRRD}
                    style={{
                      backgroundColor: activeRoute(el.path)
                        ? previewTheme.sidebarActiveItemColor ||
                          theme.sidebarActiveColor
                        : 'unset',
                      color:
                        previewTheme.sidebarTextColor || theme.sidebarTextColor,
                      paddingLeft: '50px',
                    }}
                  >
                    {el.icon !== undefined ? (
                      <>
                        <i className={el.icon} />
                        <span className='nav-link-text'>{el.name}</span>
                      </>
                    ) : el.miniName !== undefined ? (
                      <>
                        <span className='sidenav-mini-icon'>
                          {' '}
                          {el.miniName}{' '}
                        </span>
                        <span className='sidenav-normal'>{el.name} </span>
                      </>
                    ) : (
                      `• ${el.name}`
                    )}
                  </NavLink>
                </NavItem>
              ))}
        </NavItem>
      )
    })
  }

  let navbarBrandProps
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    }
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: '_blank',
    }
  }

  const scrollBarInner = (
    <div
      className='scrollbar-inner asideContainer'
      style={
        (previewTheme.sidebarBackground &&
          previewTheme.sidebarBackground !== '') ||
        (theme.sidebarBackground && theme.sidebarBackground !== '')
          ? {
              background:
                previewTheme.sidebarBackground || theme.sidebarBackground,
            }
          : {}
      }
    >
      <div>
        <div
          className='sidenav-header d-flex itemsCenter justifyCenter'
          style={{ margin: '10px' }}
        >
          {logo ? (
            <NavbarBrand
              {...navbarBrandProps}
              style={{
                width: '140px',
                cursor: 'pointer',
                padding: '0px',
              }}
            >
              <img
                alt={logo.imgAlt}
                className='d-flex itemsCenter justifyCenter'
                style={{
                  maxWidth: '100%',
                  minWidth: '100%',
                  minHeight: '80px',
                  maxHeight: '80px',
                  objectFit: 'scale-down',
                }}
                src={previewLogo || logo.imgSrc}
              />
            </NavbarBrand>
          ) : null}
        </div>

        <div className='navbar-inner'>
          <Collapse navbar isOpen={true}>
            <Nav navbar>
              <NavItem className={activeRoute('/dashboard')} key={'dashboard'}>
                <NavLink
                  to='/dashboard'
                  activeClassName=''
                  onClick={closeSidenav}
                  tag={NavLinkRRD}
                  style={{
                    backgroundColor: activeRoute('/dashboard')
                      ? previewTheme.sidebarActiveItemColor ||
                        theme.sidebarActiveColor
                      : 'unset',
                    color:
                      previewTheme.sidebarTextColor || theme.sidebarTextColor,
                  }}
                >
                  <i className='ni ni-shop text-primary' />
                  <span className='nav-link-text'>
                    {language?.language?.data?.settings
                      ? language.language.data.settings.dashboard
                      : ''}
                  </span>
                </NavLink>
              </NavItem>
              {createLinks(routes)}
            </Nav>

            {hostname && hostname.includes('pollozone') ? (
              <div className='d-flex'>
                <Button outline color='info' className='mt-3 py-2'>
                  <span
                    onClick={() => onSwitchApps()}
                    className='nav-link-text'
                  >
                    Old Version
                  </span>
                </Button>
              </div>
            ) : (
              ''
            )}
          </Collapse>
        </div>
      </div>
      <div>
        <div
          className={classnames('sidenav-toggler d-none d-xl-block ', {
            active: sidenavOpen,
          })}
        >
          <div className='sidenav-toggler-inner wAuto dFlex justifyCenter'>
            {sidenavOpen ? (
              <FontAwesomeIcon
                icon={faXmark}
                className='icon sidenav-toggler-line'
                tabIndex='0'
                onClick={toggleSidenav}
              />
            ) : (
              <FontAwesomeIcon
                icon={faBars}
                className='icon sidenav-toggler-line'
                tabIndex='0'
                onClick={toggleSidenav}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <Navbar
      className={
        'sidenav navbar-vertical navbar-expand-xs navbar-light bg-white ' +
        (rtlActive ? '' : 'fixed-left')
      }
      // onMouseEnter={onMouseEnterSidenav}
      onMouseLeave={onMouseLeaveSidenav}
    >
      {navigator.platform.indexOf('Win') > -1 ? (
        <PerfectScrollbar>{scrollBarInner}</PerfectScrollbar>
      ) : (
        scrollBarInner
      )}
    </Navbar>
  )
}

Sidebar.propTypes = {
  // function used to make sidenav mini or normal
  toggleSidenav: PropTypes.func,
  // prop to know if the sidenav is mini or normal
  sidenavOpen: PropTypes.bool,
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  // logo
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
  // rtl active, this will make the sidebar to stay on the right side
  rtlActive: PropTypes.bool,
}

export default Sidebar
